import {makeAutoObservable} from "mobx";
import {ViewController} from "data/types/structure";
import {injectable, inject} from "inversify";
import {useNavigate} from "react-router-dom";
import {Bindings} from "data/constants/bindings";
import type {ILocalizationStore} from "data/stores/localization/localization.store";

interface IParams {
	navigate: ReturnType<typeof useNavigate>;
}
export interface IHocFriendsRedirectController extends ViewController<IParams> {
	i18n: ILocalizationStore;
}

@injectable()
export class HocFriendsRedirectController implements IHocFriendsRedirectController {
	constructor(@inject(Bindings.LocalizationStore) public readonly i18n: ILocalizationStore) {
		makeAutoObservable(this);
	}

	init(param: IParams) {
		const params = new URLSearchParams(window.location.search);
		const groupId = params.get("groupId");

		if (groupId) {
			param.navigate(`/head_to_head/friends/${groupId}`);
		}
	}
}
